<template>
  <SelectorPanel
    type="grdHome"
    text="Home"
    :disabled="disabled"
    :force-close="forceClose"
    :url-path="urlPath"
    :disable-close="true"
    :force-full-screen="true"
  >
    <v-container fluid>
      <v-row dense row>
        <v-col>
          <h1 class="mb-3 text-center hyp-header-text">Global Risk Data</h1>
        </v-col>
      </v-row>
      <v-row dense row>
        <v-col class="col-4">
          <GrdHomeHeadlines></GrdHomeHeadlines>
        </v-col>
        <v-col class="col-4">
          <GrdHomeGlobalRiskData></GrdHomeGlobalRiskData>
        </v-col>
        <v-col class="col-4">
          <GrdHomeEvacRiskChanges></GrdHomeEvacRiskChanges>
        </v-col>
      </v-row>
    </v-container>
  </SelectorPanel>
</template>

<script>
export default {
  name: "GrdHomeSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    GrdHomeHeadlines: () => import("@/components/grd/home/GrdHomeHeadlines"),
    GrdHomeGlobalRiskData: () =>
      import("@/components/grd/home/GrdHomeGlobalRiskData"),
    GrdHomeEvacRiskChanges: () =>
      import("@/components/grd/home/GrdHomeEvacRiskChanges"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    forceClose: null,
    urlPath: "/grd",
  }),
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
  },
};
</script>

<style scoped>
.hyp-header-text {
  font-weight: bold !important;
}
</style>
